module.exports = __webpack_public_path__ + "static/media/connect-thumbsup-home.c460401d.svg";